import useChatPage from "./hooks/useChatPage";
import MessageList from "./MessageList";
import MessageComposer from "./MessageComposer";
import styles from "./chatPage.module.css";

const ChatPage = () => {
  const { messages, onSubmit, waiting, composerEnabled } = useChatPage();

  return (
    <div className={styles.chatPage}>
      <MessageList {...{ messages, waiting }} />
      <MessageComposer {...{ onSubmit, composerEnabled }} />
    </div>
  );
};

export default ChatPage;
